
import React, { Component } from 'react'
import { Stepper } from '@operations/shared';
import { bulkLostCollections } from '../../utils/apisConsts';
import { bulkUploadLostCollectionCols } from '../../utils/bulkSheetsTemplates';
import UploadBulkCollections from './UploadLostCollections';
import ConfirmationCollection from './confirmation';

class BulkUploadLostCollection extends Component {
    state = {
        componentSteps: [
            {
                title: 'Upload Lost Collections',
                content: <UploadBulkCollections validCols={bulkUploadLostCollectionCols} fileUrl={`https://elasticbeanstalk-us-east-1-927288046810.s3.amazonaws.com/Nowpay-Docs/BulkCreateLostCollections.xlsx`}/>,
                id: 0,
            }, {
                title: 'Result of Lost Collections',
                content: <ConfirmationCollection apiLink={bulkLostCollections} dataKey={'lostCollections'}/>,
                id: 1
            },
        ]
    }

    render() {
        const { componentSteps } = this.state;
        return (
            <>
                <div className='bulkCreateProducts'>
                    <Stepper componentSteps={componentSteps} />
                </div>
            </>
        )
    }
}

export default BulkUploadLostCollection
